import { apiGetList } from './ApiBaseActions';
export const API_GET_LIST_PROFESSIONAL_PROPOSAL_RFP = 'API_GET_LIST_PROFESSIONAL_PROPOSAL_RFP';
export const API_GET_LIST_PROFESSIONAL_PROPOSAL_RFP_SUCCESS = 'API_GET_LIST_PROFESSIONAL_PROPOSAL_RFP_SUCCESS';
export const API_GET_LIST_PROFESSIONAL_RFP = 'API_GET_LIST_PROFESSIONAL_RFP';
export const API_GET_LIST_PROFESSIONAL_RFP_SUCCESS = 'API_GET_LIST_PROFESSIONAL_RFP_SUCCESS';
export const apiGetListProfessionalProposalRfp = () => apiGetList(API_GET_LIST_PROFESSIONAL_PROPOSAL_RFP, '/professional/rfp_proposal');
export const apiGetListProfessionalRfp = (page) => apiGetList(API_GET_LIST_PROFESSIONAL_RFP, '/professional/rfp_offered', { page }, { page });
